import { FlexSmartShareQuery, FlexSmartShareArgs, FlexSmartShareResponse } from '../../autogenerated/ZoomBridge';

export default class FlexSmartLinkExecutor {
  constructor(fuids, name, destDir, isWritable, isSuffix) {
    this.fuids = fuids;
    this.name = name;
    this.destDir = destDir;
    this.isWritable = isWritable;
    this.isSuffix = isSuffix;
  }

  run(): Promise<FlexSmartShareResponse> {
    const query = new FlexSmartShareQuery();
    const msg = new FlexSmartShareArgs();
    msg.setSrcFuids(this.fuids);
    msg.setName(this.name);
    msg.setDestDir(this.destDir);
    msg.setIsWritable(this.isWritable);
    msg.setIsSuffix(this.isSuffix);
    query.message = msg;
    return query.run();
  }
}
